export const REMEMBER_USER = "REMEMBER_USER";
export const APP_SETTINGS_UPDATE = "APP_SETTINGS_UPDATE";
export const RESET_STATE = "RESET_STATE";

export const rememberUser = (user) => ({
  type: REMEMBER_USER,
  payload: { user },
});

export const resetState = () => {
  return {
    type: RESET_STATE,
  };
};

export const appSettingUpdate = (payload) => {
  return {
    type: APP_SETTINGS_UPDATE,
    payload,
  };
};
